import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import '@/pages/containers/inquiryMessage/scss/index.scss';

export default class UserCollect extends React.Component <any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			goods_id: this.props.location.state ? this.props.location.state.id : '',
			goodData: [],
			page: 1,
		};
	}

	componentDidMount() {
		const _THIS = this;
		this.getGoodData();

		window.onscroll = function() {
	        if(document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 50||document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 50) {
	            if(!_THIS.loadBtn){
	                return ;
	            }
	            
	            _THIS.setState({
	                page: _THIS.state.page + 1,
	            }, () => {
	                if (_THIS.loadBtn) {
	                	_THIS.getGoodData()
	                }
	            });
	        }
	    }
	}

	render() {
		return (
			<div className="page-inquiryDetails">
				<div className="default-card-list">
					{
						this.state.goodData.map((item: any, k: number) => {
							return (
								<div className="default-card" key={k}>
									<ul className="card-contetn">
										<li className="card-row">
											<span className="label">收藏用户名</span>
											<span className="text line-clamp-1">{item.userName}</span>
										</li>
										<li className="card-row">
											<span className="label">公司名称</span>
											<span className="text line-clamp-1">{item.companyName}</span>
										</li>
										<li className="card-row">
											<span className="label">联系方式</span>
											<span className="text line-clamp-1">{item.mobilPhone}</span>
										</li>
										<li className="card-row">
											<span className="label">收藏时间</span>
											<span className="text line-clamp-1">{item.created_at}</span>
										</li>
									</ul>
								</div>
							)
						})
					}
					
				</div>
				{
					!this.state.goodData.length ? 
					<div className="upgrade">
						<div className="upgrade-top"><img src={require('@/assets/images/nothing.png')} /><p>暂无内容</p></div>
					</div> :''
					
				}
			</div>
		)
	}

	private loadBtn = true;

	private async getGoodData() {
		if(!this.loadBtn) {
	        return ;
	    }

	    this.loadBtn = false;

		const r = await request({
			method: "get",
			url: `${config.MALLAPI}api/wshop/collection/user-list?goods_id=${this.state.goods_id}&page=${this.state.page}`,
		})

		if(r.error_code === 0) {
			if(this.state.page >= r.data.page_count) {
	            this.loadBtn = false;
	        }else {
	            this.loadBtn = true;
	        }

			this.setState({
				goodData: this.state.goodData.concat(r.data.model)
			})
		}
		// console.log(r, 'r')
	}
}